/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
// --- Import hooks
import useMakeRequest from "../../../../hooks/useMakeRequest";
// --- Import cpmponents
import Button from "../../../../components/UI/Button/Button";
import Preloader from "../../../../components/UI/Preloader/Preloader";
import ModalWindow from "../../../../components/UI/ModalWindow/ModalWindow";
import NotificationError from "../../../../components/UI/NotificationError/NotificationError";
import RestorePasswordForm from "../RestorePasswordForm/RestorePasswordForm";
// ---- Import images
import style from "./RestorePassword.module.sass";
import icon from "../../../../assets/images/restore_password/icon.svg";

function RestorePassword() {
  const [isUpdatedSuccessfully, setUpdatedSuccessfully] = useState(false);
  const [isContinue, setContinue] = useState(false);

  const [setParams, data, isLoading, hasError, error] = useMakeRequest();

  const [
    setParamsKey,
    dataKey,
    isLoadingKey,
    hasErrorKey,
    errorKey,
  ] = useMakeRequest();
  // --- Key verification request

  // Parameter for test:
  // ?key=UlZVUFhXVkoJCQ55XlRYUFUXWlZURUUJWAAMDA9dCwwKXw4LAFsLAQ8JClwBW1pdDVgBX1taAA%3D%3D
  const key = window.location.search.split("?key=").pop();
  useEffect(() => {
    setParamsKey({
      c: "accountStore",
      a: "checkRestoreKey",
      p: { key },
    });
  }, []);

  // --- Redirect to '/login' on click
  if (isContinue || !key) {
    return <Redirect to="/myApps" />;
  }
  return (
    <>
      {dataKey && dataKey && !hasErrorKey && !errorKey && (
        <div className={style.restorePassword}>
          <div className={style.header}>
            <img className={style.userIcon} src={icon} alt="" />
            <div className={style.title}>Update your password</div>
            <div className={style.currentUserEmail}>{dataKey}</div>
          </div>
          {hasError && error && (
            <div className={style.restorePasswordError}>{error}</div>
          )}
          {isLoading && (
            <Preloader
              color="#fff"
              width="50px"
              className={style.preloaderRestorePass}
            />
          )}

          <div className={style.restorePasswordFormWrapper}>
            {isUpdatedSuccessfully && (
              <ModalWindow
                isOpen={isUpdatedSuccessfully} // If the password update was successful, a modal window opens
                title="your password has been updated"
                onCancel={() => setContinue(true)}
              >
                <div className={style.notificationMessage}>
                  For security purposes we’ve sent an email to your account
                  confirming this change.
                </div>
                <Button
                  className={`btn-primary ${style.btnContinue}`}
                  onClick={() => setContinue(true)}
                >
                  Continue
                </Button>
              </ModalWindow>
            )}
            <RestorePasswordForm
              setParams={setParams}
              uniqueKey={key}
              data={data}
              setUpdatedSuccessfully={setUpdatedSuccessfully}
              hasError={hasError}
            />
          </div>
        </div>
      )}
      {!isLoadingKey && hasErrorKey && errorKey && (
        <NotificationError
          classWrapper={`payment-section__error ${style.errorKey}`}
          classText="payment-section__error-text"
          errorMessage={errorKey}
        />
      )}
    </>
  );
}

export default RestorePassword;
